/**
 * Jamaican dollar.
 */
export var JMD = {
  code: 'JMD',
  base: 10,
  exponent: 2
};